import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'react-bootstrap';

class HotelUnsubscribeForm extends React.Component {
  render() {
    return (
      <div className="container">
        <div className="row">
          <div className="col-md-4">
            <h3>Please remove my access to this hotel.</h3>
            <p>You will not longer be able to view Catch Booking Requests for this property.</p>
            <Button bsStyle="danger" onClick={this.props.handleRemove}>Remove</Button>
          </div>
        </div>
      </div>
    );
  }
}
HotelUnsubscribeForm.propTypes = {
  handleRemove: PropTypes.func.isRequired,
};

export default HotelUnsubscribeForm;



// WEBPACK FOOTER //
// src/routes/feedback/components/HotelUnsubscribeForm.js